<template>
    <section
        :class="[top_offset, containerClass]" :style="getSectionStyle()"
    >
        <section>
            <section>
                <CampMenuButton/>

                <div
                    v-for="(item, index) in SiteMenu" :key="index"
                >
                    <Link
                        :class="page.url.startsWith(item.path) && !page.url.startsWith('/?') && !page.url !== '/' && item.path !== '/' && !item.path.startsWith('/?') ? 'border-main-accent': (page.url.startsWith('/?') || page.url === '/') && item.path === '/' ? 'border-main-accent' : 'border-main-tint hover:border-gray-300'"
                        :href="item.path"
                        class="relative flex w-full items-center mb-3 cursor-pointer border py-2 px-[10px] text-main-primary"
                        style="border-radius: 10px"
                    >
                        <span
                            :class=" page.url.startsWith(item.path) && !page.url.startsWith('/?') && !page.url !== '/' && item.path !== '/' && !item.path.startsWith('/?') ? 'text-main-accent': (page.url.startsWith('/?') || page.url === '/') && item.path === '/' ? 'border-main-accent' : 'text-main-secondary'"
                            class="md:mr-2" v-html="item.icon"
                        ></span>
                        {{ item.displayName }}
                        <span
                            v-if="item.displayName === 'Вакансии' && showVacancyDot"
                            class="hidden xl:block w-2.5 h-2.5 rounded-full bg-main-pink absolute top-2 left-2.5"
                        ></span>
                    </Link>
                </div>
            </section>
            <!-- partners -->
            <section class="my-10">
                <Link
                    v-for="item in partners" :key="item.id"
                    :data-click-id="item.name === 'AgileFluent' ? 'left_menu_2_agilefluent' : null"
                    :href="'/partners/'+item.slug" class="flex items-center my-4 cursor-pointer ml-2"
                >
                    <div
                        class="partners-img-wrap flex items-center jusify-center bg-white p-1"
                        style="border-radius: 10px;"
                    >
                        <img
                            :src="item.logo_url" alt="" class="h-full w-full object-contain"
                        >
                    </div>
                    <h4 class="text-sm text-main-primary hover:text-main-accent font-medium">
                        {{ item.name }}</h4>
                </Link>
                <Link
                    v-if="checkAccess([1,7])"
                    class="text-xxs uppercase text-main-secondary hover:text-main-accent my-5 ml-2" href="/partners"
                >Все компании
                </Link>
            </section>
            <!-- camps -->
            <section class="mt-10">
                <div
                    v-for="(item, index) in camps" :key="index" class="flex items-center my-4 cursor-pointer ml-2"
                    @click="proceedLink(item.path)"
                >
                    <img
                        v-if="!item.isSvg" :src="'/img/icons/'+item.logo" alt="" class="" height="30"
                        style="border-radius: 10px; margin-right: 8px;" width="30"
                    >
                    <span
                        v-else class="cursor-pointer flex items-center justify-center mr-2" v-html="item.logo"
                    />
                    <h4 class="text-base font-normal text-main-primary hover:text-main-accent">{{ item.name }}</h4>
                </div>
                <div
                    class="flex items-center my-4 cursor-pointer ml-2"
                    @click="proceedLink('https://productland.ru/management')"
                >
                    <img
                        alt="" class="" height="30" src="/pictures/banners/map-build2.svg"
                        style="border-radius: 10px; margin-right: 8px;" width="30"
                    >
                    <h4 class="text-base font-normal text-main-primary hover:text-main-accent">Карта города</h4>
                </div>
            </section>

        </section>


        <section
            v-if="(page.url !== '/' && !page.url.startsWith('/?')) || !containerClass" class="px-2 hidden lg:block"
        >

            <div class="flex flex-col mb-4">
                <h5 class="text-[#756F86] text-[16px] font-medium mb-3">Контакты</h5>
                <a
                    class="lg:text-[10px] xl:text-[12px] text-[#383247]" href="mailto:info@productland.ru"
                >info@productland.ru</a>
            </div>

            <section class="flex gap-4 mb-4">
                <span
                    class="cursor-pointer text-main-primary" @click="proceedLinkSocials('tg')"
                    v-html="collection.tgDark.path"
                />
                <span
                    class="cursor-pointer text-main-primary" @click="proceedLinkSocials('vk')"
                    v-html="collection.vk.path"
                />
            </section>

            <div class="mb-7">
                <Link class="block text-[12px] text-[#383247] leading-[15px]" href="/privacy-policy">Политика обработки
                    персональных данных
                </Link>
            </div>

            <div class="text-[14px] text-[#383247]">© ProductLand, {{ year }}</div>

        </section>

        <slot name="sideMenuFooter"></slot>

    </section>


</template>
<script setup>
import {Link} from '@inertiajs/vue3';
import {checkAccess, page} from '@/shared/helpers.js';
import {computed, onMounted, ref, watch} from 'vue';
import dayjs from 'dayjs';
import {top_offset} from '@/shared/Banners/Composables/useBanners.js';
import {SiteMenu} from '@/Layouts/Menu/Composables/useMenu.js';
import CampMenuButton from '@/Layouts/Menu/CampMenuButton.vue';
import {icons as collection} from '@/shared/assets.js';
import {useWindowDimensions} from '@/Pages/Main/helpers/dimentions.ts';

let showVacancyDot = ref(false);
let tagsOpen = ref(false);
let isMainPage = computed(() => {
    return page.url === '/' || page.url.startsWith('/?');
});
const {laptopXL_1} = useWindowDimensions();

const {containerClass} = defineProps({
    containerClass: {
        type: String,
        default: ''
    }
});

const getSectionStyle = () => isMainPage.value || containerClass ? {
    // height: 'calc(100vh - 32px - 94.5px)',
    overflowX: 'hidden',
    width: laptopXL_1 ? 'max-content' : '100%'
} : {};

let modalOpened = ref(false);
const routes = {
    insta: 'https://www.instagram.com/productcamp.ru',
    fb: 'https://www.facebook.com/groups/productcamprussia',
    tg_old: 'https://t.me/teamleadcampchat',
    tg: 'https://t.me/productland_russia',
    vk: 'https://vk.com/productcamp',
    youtube: 'https://www.youtube.com/channel/UCN97-wQgHScYUhnz31_NdeA',
    devs: 'https://productland.ru/dev'
};

const partners = ref([]);
const camps = [
    {path: 'https://productcamp.ru/', name: 'productcamp', logo: collection.new_camp_big.path, isSvg: true},
    {path: 'https://devscamp.ru/', name: 'devscamp', logo: 'devscamp.png', isSvg: false}
];

const selected = ref(null);
let vacancyFlag = ref(null);

let year = computed(() => {
    return dayjs().format('YYYY');
});

onMounted(() => {
    axios.get('/side_menu') // fetch partners displayed in sidemenu
        .then(response => {
            partners.value = response.data;
        })
        .catch(error => {
            console.log(error);
        });
    SiteMenu.value.filter(el => {
        el.expand = el.path.substr(0, 2).startsWith(window.location.pathname.substr(0, 2));
    });

    vacancyFlag.value = localStorage.getItem('showVacancyFlag');

    if (!vacancyFlag.value) {
        localStorage.setItem('showVacancyFlag', 'not-checked');
    }

    if (vacancyFlag.value && vacancyFlag.value === 'not-checked') {
        showVacancyDot.value = true;
    }
});

watch(vacancyFlag, () => {

    if (vacancyFlag.value && vacancyFlag.value === 'not-checked' && page.url.startsWith('/career/vacancies')) {
        showVacancyDot.value = false;
        localStorage.setItem('showVacancyFlag', 'checked');
    }
});

function select(input) {
    selected.value = input;
}

function proceedLinkSocials(key) {
    window.open(routes[key], '_blank').focus();
}

function collapseMenu(item) {
    console.log('item.name', item.name);

    SiteMenu.value.filter(el => {
        console.log('el.name', el.name);
        el.expand = false;

        if (el.name === item.name) {
            el.expand = true;
        }
    });
}

function proceedLink(path) {
    window.open(path, '_blank').focus();
}

</script>

<style>

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s, transform .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
    transform: translateX(-10px);
}

.partners-img-wrap {
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-right: 8px;
    border: 1px solid #d1d9e2;
    border-radius: 10px;
}

.sticky-sidebar {
    padding-right: 8px;
    overflow-y: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-scroll-snap-type: y mandatory;
    scroll-snap-type: y mandatory;
}

.sticky-sidebar::-webkit-scrollbar-track {
    /* background-color: #D1D9E2; */
    border-radius: 10px;
    width: 4px;
    height: 8px;
}

.sticky-sidebar::-webkit-scrollbar {
    width: 4px;
    height: 8px;
}

.sticky-sidebar::-webkit-scrollbar-thumb {
    background: #D1D9E2;
    border-radius: 10px;
    width: 4px;
    height: 8px;
    display: none;
}

.sticky-sidebar:hover::-webkit-scrollbar-thumb {
    display: block;
}
</style>
